import { createFileRoute } from '@tanstack/react-router';
import { NotificationSettingsPage } from '@/features/inbox/notification-settings';

export const Route = createFileRoute('/w/$workspaceId/settings/notifications')({
  component: NotificationSettingsPage,
});
